import { Checkbox, IconButton, Icons, Tooltip } from '@healthinal/ui';

import type { MedicationDto } from '../../../../../api/generated/model';
import { TruncateText } from '../../../../../components/TruncateText';

type Props = {
  medication: MedicationDto;
  onToggleActive?: (medication: MedicationDto) => void;
  onShowHistory?: (medication: MedicationDto) => void;
  isPending?: boolean;
};

export function MedicationTableRow({ medication, onToggleActive, onShowHistory, isPending }: Props) {
  return (
    <>
      <td>
        <TruncateText>{medication.name ?? '-'}</TruncateText>
      </td>
      <td onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center' }}>
        <Checkbox checked={!!medication.isActive} disabled={isPending} onClick={() => onToggleActive?.(medication)} />
      </td>
      <td onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center' }}>
        <Tooltip title="Verlauf">
          <IconButton
            size="sm"
            variant="plain"
            color="neutral"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onShowHistory?.(medication);
            }}>
            <Icons.History />
          </IconButton>
        </Tooltip>
      </td>
    </>
  );
}
